import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-partners-openforge-benefits-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './partners-openforge-benefits-section.component.html',
  styleUrl: './partners-openforge-benefits-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeBenefitsSectionComponent {}
